module.exports = [
	{
		"featureType": "all",
		"elementType": "labels",
		"stylers": [
			{
				"gamma": 0.26
			},
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "all",
		"elementType": "labels.text",
		"stylers": [
			{
				"visibility": "on"
			},
			{
				"color": "#615d5d"
			}
		]
	},
	{
		"featureType": "all",
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"lightness": "0"
			}
		]
	},
	{
		"featureType": "all",
		"elementType": "labels.text.stroke",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "administrative.province",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "on"
			},
			{
				"lightness": -50
			}
		]
	},
	{
		"featureType": "administrative.province",
		"elementType": "labels.text",
		"stylers": [
			{
				"lightness": 20
			}
		]
	},
	{
		"featureType": "administrative.province",
		"elementType": "labels.text.stroke",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "poi",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "road",
		"elementType": "all",
		"stylers": [
			{
				"hue": "#ffffff"
			}
		]
	},
	{
		"featureType": "road",
		"elementType": "labels.text.stroke",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "road.highway",
		"elementType": "geometry",
		"stylers": [
			{
				"lightness": "85"
			}
		]
	},
	{
		"featureType": "road.highway",
		"elementType": "geometry.fill",
		"stylers": [
			{
				"color": "#cfcfcf"
			},
			{
				"lightness": "25"
			}
		]
	},
	{
		"featureType": "road.highway",
		"elementType": "geometry.stroke",
		"stylers": [
			{
				"color": "#d0d0d0"
			}
		]
	},
	{
		"featureType": "road.arterial",
		"elementType": "geometry",
		"stylers": [
			{
				"lightness": 20
			}
		]
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ./src/modules/googlemapstyles.json
 ** module id = 320
 ** module chunks = 0
 **/